import { TableCells, Consumption } from 'models';

function renderValue(value: number | null) {
  return value === 0 || !value ? value : value.toFixed(4);
}

export const consumptionTableCells: TableCells<Consumption>[] = [
  {
    id: 'Meter.Name',
    type: 'string',
    label: '##attribute#uds_consumption#uds_meterid',
    small: true,
    xs: true,
  },
  {
    id: 'Date',
    type: 'date',
    format: 'd.M.yyyy',
    label: '##attribute#uds_consumption#uds_date',
    small: true,
    xs: true,
  },
  {
    id: 'Value',
    type: 'number',
    label: 'Mittarilukema',
    render: (item) => renderValue(item.Value),
  },
  {
    id: 'Usage',
    type: 'number',
    label: 'Kulutus',
    render: (item) => renderValue(item.Usage),
  },
];
